const sameOrigin = require('same-origin')

const buildUrl = require('./build-url')

module.exports = isSameOrigin

function isSameOrigin(urlObj) {
  if (!urlObj.host && !urlObj.hostname) {
    return true
  }

  return sameOrigin(window.location, buildUrl(urlObj))
}
